import { render } from "./Warning.vue?vue&type=template&id=4fc15d2b&scoped=true"
const script = {}

import "./Warning.vue?vue&type=style&index=0&id=4fc15d2b&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc15d2b"]])

export default __exports__